<template>
    <div v-if="courses_modules.length > 0">
        <div v-for="(item, mindex) in courses_modules" :key="mindex">
            <div class="col-xs-12 override-padding mb-2">
                <div class="row mt-2">
                    <div class="col-12 module-wrapper">
                        <div class="float-left courses_row courses_content_1 text-align-left">{{ formatModuleName(item.module_name, mindex)  }}</div>
                        <div class="float-left courses_row courses_content_3">
                            <i class="fa fa-check" v-if="item.pass === 'Pass'"></i>
                            <span v-else>&nbsp;</span>
                        </div>
                        <div class="float-left courses_row courses_content_4">
                            <span v-if="item.score != 'N/A'">{{ item.score }}%</span>
                            <span v-else>&nbsp;</span>
                        </div>
                        <div class="float-left courses_row courses_content_6">
                            <span v-if="item.module_attended_date != 'N/A'">{{ item.module_attended_date | formatModuleDate }}</span>
                            <span v-else>&nbsp;</span>
                        </div>
                    </div>
                </div>
                <hr class="courses_hr" v-if="mindex == courses_modules.length">
            </div>
        </div>
    </div>
    <div v-else>
        <div class="col-xs-12 override-padding">
          <div class="no_course_header">{{ course_msg }}</div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import moment from 'moment';

Vue.filter('formatModuleDate', function(value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY')
  }
});

export default {
    data(){
        return{
            courses_modules: [],
            course_msg: '',
        }
    },
    methods: {
        getModules(userId, courseId, displayFlag) {
          if (displayFlag) {
            var account_id = this.$parent.accountId;
            this.course_msg = 'Loading...';
            axios('/custom/account-courses',
            {
              method: 'POST',
              data: {
                user_id: userId,
                course_id: courseId,
                account_id: account_id,
                learn_lms_key: 'MENTOR_BAZINGA!!!'
              }
            }
            )
            .then(response => {
              if (response.data.success) {
                this.courses_modules = response.data.data.courses[courseId].modules;
                if (this.courses_modules.length == 0) {
                  this.course_msg = 'No course is completed';
                }
              }
            })
            .catch(error => {

            });
          } else {
            this.courses_modules = [];
            this.course_msg = '';
          }
        },
        formatModuleName(name, num) {
          return (num +1) + '. ' + name;
        }
    }
}
</script>

<style scoped>
/* Courses css start */
.courses_heading_0 {
  width: 5%;
  font-weight: 900;
}
.courses_heading_1 {
  width: 30%;
}
.courses_heading_2 {
  width: 10%;
}
.courses_heading_3 {
  width: 8%;
}
.courses_heading_4 {
  width: 12%;
}
.courses_heading_5 {
  width: 15%;
}
.course_header {
  background: #707070 none repeat scroll 0 0 !important;
  border-bottom: 2px solid #ddd;
  border-top: 0 none;
  color: #fff;
  float: left;
  line-height: 1.42857;
  padding: 8px 3px;
  vertical-align: bottom;
}
.courses_content_1 {
  width: 65%;
}
.courses_content_2 {
  width: 6%;
}
.courses_content_3 {
  width: 5%; text-align: right;
}
.courses_content_4 {
  width: 15%; text-align: right;
}
.courses_content_5 {
  width: 11%;
}
.courses_content_6 {
  width: 15%; text-align: right;
}
.courses_content_7 {
  width: 22%;
}
.courses_row {
  border-bottom: 1px solid #00ACEE;
  padding: 5px 0px;
}
.courses_hr {
  margin: 30px 0px;
  border-bottom: 2px solid #00ACEE;
}
@media (max-width: 768px) {
  .course_header {
    padding: 8px 1px;
    font-size: 11px;
  }
}
.download_cert_link, .download_cert_link:hover, .download_cert_link:active, .download_cert_link:focus{
  color: #FFF !important;
}
.no_course_header {
  background: #FFFFFF none repeat scroll 0 0 !important;
  border-bottom: 2px solid #ddd;
  border-top: 0 none;
  color: #FF0000;
  float: left;
  line-height: 1.42857;
  padding: 8px 3px;
  vertical-align: bottom;
  width: 100%;
  text-align: center;
  margin-bottom: 10px;
}
.module-wrapper {
  display: flex;
}
/* Courses css end */
</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/course_user_results_modules.vue